<template>
  <div class="suits-background">
    <h1 class="mb-4 text-xs-center suit-padding custom-font" style="font-size: 40px;">Products</h1>
    <h2 class="mb-4 text-xs-center suit-padding custom-font" style="font-size: 20px;">Buy any 2 suits for $460! Please screenshot your designs and email to info@caos.store for a Paypal or Stripe invoice.</h2>
    <v-layout fill-height row wrap>
      <v-flex class="pa-3" v-for="(item, i) in items" :key="i" xs12 sm6 md4 lg3>
        <v-card color="#E8DCCA" height="100%" tile :to="geturl(item.id)">
          <!-- <v-img class="suit-img" :src="getimg(item.title)" :alt="item.title" aspect-ratio="1.3"></v-img> -->
          <v-card-title primary-title> 
            <div>
            <!-- Make a second list, modify what displays, but keep the previous title/descriptions for the link -->
              <h3 class="mb-0 custom-font" style="font-size: 24px">{{ item.title }}</h3>
            </div>
          </v-card-title>
          <v-card-text class="px-3 py-2 custom-font" style="font-size: 16px;" v-if="item.description">
            {{ item.description }}
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { db } from "../firebase";// use only when need push data
export default {
  props: ["url"],
  data() {
    return {
      items: [
        //  {
        //   title: "Gp Suit",
        //   description:
        //     "Brand new GP motorbike leather racing suit is custom engineered for professional bikers to fulfill their passion on the track with great safety. This suit features excellent design & comfort, 100% genuine cowhide leather, approved internal & external protectors on the knee, shoulder, elbows and back, YKK zippers for performance, and outer knee sliders for performance. Available in both men's and women's fitting, and all sizes."
        // },
        // {
        //   title: "Jacket",
        //   description:
        //     "This jacket is made from taslan or polycotton. Its main use is for tandem instructors to easily put on a layer for warmth.  Nice and sturdy!",
        // },
        // {
        //   title: "Tandem Pants",
        //   description:
        //     "These tandem pants are made of the same materials as the Freefly One. They provide excellent drag for the legs. They have a full cordura rear for slide in landings. They match great with a jacket or camera jacket.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/Tandem%20Pants.jpg"
        //   },
        // {
        //   title: "RW Pants",
        //   description:
        //     "RW pants are the lower half of our slimline RW suit. These pants have grippers to provide an ability to link up with your friends without wearing an entire RW suit.",
        // },
        // {
        //   title: "Jacket And Tandem Pants",
        //   description:
        //     "A combination of our jacket and tandem pants. A great deal if you planned on buying both!",
        // },
        // {
        //   title: "Jacket And Slimline Rw Pants",
        //   description:
        //     "A combination of our jacket and slimline RW Pants. A great deal if you planned on buying both!",
        // },
        // {
        //   title: "Camera Jacket",
        //   description:
        //     "Camera jacket comes with Reserve Static Line clips and wings to help you achieve a variety of falling speeds. If you really need to slow down, this is your suit. For extra brakes, we recommend using the default fabric selection as the main material.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/Camera%20Jacket.jpg"
        //   },
        // {
        //   title: "Camera Jacket And Tandem Pants",
        //   description:
        //     "A combination of Camera Jacket and Tandem Pants. A great deal if you planned on buying both!",
        // },
        // {
        //   title: "Camera Jacket And Slimline Rw Pants",
        //   description:
        //     "A combination of Camera Jacket and Slimeline RW Pants. A great deal if you planned on buying both!",
        // },
        // {
        //   title: "Freefly One",
        //   description:
        //     "Freefly One is your everyday freefly suit. It has a soft shell in the areas you need and its a nice form fitting suit. This also works well in the tunnel. Includes cordura knees and rear.",
        // },
        // {
        //   title: "Freefly Three",
        //   description:
        //     "Freefly Three is suited for beginners or tandems, as it has 1 panel up the rear leg for strength. The upper arm on the suit has a taped off panel below the elbow where the soft shell is.",
        // },
        // {
        //   title: "Hybrid One",
        //   description:
        //     "Hybrid One suit is designed for the tunnel and the sky. Hybrid One does not include knee pads.",
        // },
        // {
        //   title: "Hybrid Two",
        //   description:
        //     "Hybrid Two includes knee pads and has 1 panel up the rear of the leg, so it's better for the less advanced in the tunnel or for slide-in landings.",
        // },
        // {
        //   title: "Rw",
        //   description:
        //     "RW suit is a basic everyday Relative Work suit. It includes grippers and booties. This RW suit gives you a flatter surface to fly on.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/RW%20Suit.jpg"
        // },
        // {
        //   title: "Slimeline RW",
        //   description:
        //     "Slimline RW is a cross between freefly and our normal RW suit. It has a freefly upper body and freefly thighs/arms, for a bit more dynamic flying or to simply speed you up a tad. It is more form fitting.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/RW%20Slimline.jpg"
        //   },
        // {
        //   title: "Tunnel",
        //   description:
        //     "Tunnel suit, we use a high quality stretch material that’s very fast. It’s great for dynamic and static flying. We now offer a cordura bust and knees so it’s even tougher if you want to use it outside, although many use it without the cordura.",
        // },
        // {
        //   title: "Instructor Suit",
        //   description:
        //     "Instructor suits look like our freefly suits, but include zippers on each arm and leg that release more fabric to slow you down.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/Instructor.jpg"
        // },
        // {
        //   title: "Summer One",
        //   description:
        //     "Summer One is the same as freefly one, but with short arms and legs. If you want short arms and long legs or long arms and short legs, just measure your full inseam or full arm and list in notes you want a full length leg or arm.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/Summer%201.jpg"
        //   },
        // {
        //   title: "Summer Two",
        //   description:
        //     "Summer Two is the same as Hybrid One, but with short arms and legs. If you want short arms and long legs or long arms and short legs, just measure your full inseam or full arm and list in notes you want a full length leg or arm.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/Summer%202.jpg"
        //   },
        // {
        //   title: "Tandem Shorts",
        //   description:
        //     "These shorts are best used for tandems, as they are a bit more reinforced.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/Tandem%20Shorts.jpg"
        // },
        // {
        //   title: "Swoop Pants",
        //   description:
        //     "Swoop Pants are basically the lower half of the Hybrid suit. They contain more soft shell on the hips for more flexibility.",
        // },
        // {
        //   title: "Swoop Shorts",
        //   description:
        //     "Swoop Shorts are basically the lower half of the hybrid suit, but shorter. They contain more soft shell on the hips for more flexibility.",
        //   imgURL: "https://storage.googleapis.com/caos-suits-v2/Custom%20Suits/Swoop%20Shorts.jpg"
        // }, 
      ],
    };
  },
  methods: {
    geturl(name) {
      let url = name.toLowerCase().replace(/\s/gi, "");
      return `/${this.$props.url || "suits"}/${url}`;
    },
    getDescriptions() {
      db.collection("suitdescriptions")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.items.push({
              title: doc.data().label,
              id: doc.data().id,
              description: doc.data().description,
            });
          });
        });
    },
    // pushData(){
    //   this.suits.forEach(item=>{
    //     db.collection("data").doc(item.title.toLowerCase().replace(/\s/gi,'')).set({
    //       id:item.title.toLowerCase().replace(/\s/gi,''),
    //       label:item.title,
    //       addons:[],
    //       materials:[],
    //       price: 40000,
    //       measurementid:'hB5mb8BLOuoOWSvAP2rZ',
    //       description: item.description,
    //   })
    //   })
    // },
    // getimg(name){
    //   let url=name.toLowerCase().replace(/\s/gi,'');
    //   return require(`@/assets/suits/${url}.png`);
    //   //return 'https://via.placeholder.com/550x300?text=Placeholder'

    // },
  },
  created(){
    this.getDescriptions();

    // this.pushData()
    // db.collection("data")
    //     .get()
    //     .then((querySnapshot) => {
    //       querySnapshot.forEach((doc) => {
    //         this.suits.push({title: doc.data().label, description: doc.data().description});
    //       });
    //     })
  }
};
</script>

<style lang="css">
.suit-padding {
  padding-top: 15px;
}

.suits-background {
  background-color: white;
}


.custom-font {
  font-family: poppins;
}

</style>
